/*
 * Gift wrap upgrades (Default product template).
 * This runs on its own, before any product form handler, so it still works if an
 * app or another script has registered its own <product-form>. When a gift bag
 * option is selected, the earrings and the bag are added in ONE request.
 */
(function () {
  if (window.LecGiftWrapLoaded) return;
  window.LecGiftWrapLoaded = true;

  // Read the form's own id attribute. form.id can return the hidden <input name="id">
  // (the variant field) instead, so never use form.id here.
  function formId(form) {
    return (form && form.getAttribute && form.getAttribute('id')) || '';
  }

  function getData(form) {
    if (!form || !formId(form)) return null;
    if (form._lecGiftData !== undefined) return form._lecGiftData;
    var script = document.querySelector('script[data-gift-wrap-prices="' + formId(form) + '"]');
    try {
      form._lecGiftData = script ? JSON.parse(script.textContent) : null;
    } catch (e) {
      form._lecGiftData = null;
    }
    return form._lecGiftData;
  }

  function getQuantity(form) {
    var input = document.querySelector('input[name="quantity"][form="' + formId(form) + '"]') || form.querySelector('[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function getGiftLine(form) {
    if (!form || !formId(form)) return null;
    var input = document.querySelector('input[data-gift-variant][form="' + formId(form) + '"]:checked');
    if (!input || !input.dataset.giftVariant) return null;
    return {
      id: Number(input.dataset.giftVariant),
      quantity: input.dataset.giftQuantity === 'match' ? getQuantity(form) : 1,
      price: parseInt(input.dataset.giftPrice, 10) || 0,
    };
  }

  function formatMoney(cents, format) {
    var value = cents / 100;
    function delimit(number, decimals, thousands, decimal) {
      var parts = number.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return (format || '£{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(value, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(value, 2, "'", '.');
        default: return delimit(value, 2, ',', '.');
      }
    });
  }

  // ---- Button total --------------------------------------------------------

  function updateTotal(form) {
    var button = form.querySelector('[type="submit"][name="add"]');
    var totalEl = button && button.querySelector('[data-gift-total]');
    if (!totalEl) return;
    var data = getData(form);
    var giftLine = getGiftLine(form);
    var idInput = form.querySelector('[name="id"]');
    var variantPrice = data && idInput ? data.variants[String(idInput.value)] : undefined;

    if (!data || !giftLine || variantPrice === undefined || button.hasAttribute('disabled')) {
      totalEl.hidden = true;
      totalEl.textContent = '';
      return;
    }
    totalEl.textContent = formatMoney(variantPrice * getQuantity(form) + giftLine.price * giftLine.quantity, data.moneyFormat);
    totalEl.hidden = false;
  }

  function formFor(target) {
    if (!target) return null;
    var id = target.getAttribute && target.getAttribute('form');
    if (id) return document.getElementById(id);
    return target.form || null;
  }

  function onFieldChange(event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (!(target.matches('[data-gift-variant]') || target.name === 'quantity' || target.name === 'id')) return;
    var form = formFor(target);
    if (form && getData(form)) updateTotal(form);
  }

  function initTotals() {
    document.querySelectorAll('script[data-gift-wrap-prices]').forEach(function (script) {
      var form = document.getElementById(script.dataset.giftWrapPrices);
      if (!form || form._lecGiftInit) return;
      form._lecGiftInit = true;
      var button = form.querySelector('[type="submit"][name="add"]');
      if (button) {
        new MutationObserver(function () { updateTotal(form); }).observe(button, { attributes: true, attributeFilter: ['disabled'] });
      }
      updateTotal(form);
    });
  }

  document.addEventListener('change', onFieldChange);
  document.addEventListener('input', onFieldChange);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTotals);
  } else {
    initTotals();
  }

  // ---- Add to basket -------------------------------------------------------

  function setLoading(form, loading) {
    var button = form.querySelector('[type="submit"][name="add"]');
    if (!button) return;
    var spinner = button.querySelector('.loading-overlay__spinner');
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function showError(form, message) {
    var wrapper = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message-wrapper');
    if (!wrapper) return;
    var text = wrapper.querySelector('.product-form__error-message');
    wrapper.toggleAttribute('hidden', !message);
    if (message && text) text.textContent = message;
  }

  // Capture phase on the document runs before any handler on the form itself.
  function addWithGift(form, event) {
    if (!(form instanceof HTMLFormElement) || !getData(form)) return false;
    var giftLine = getGiftLine(form);
    if (!giftLine) return false; // Signature packaging: let the normal add to basket run.

    var idCheck = form.querySelector('[name="id"]');
    if (!idCheck || !Number(idCheck.value)) return false;

    event.preventDefault();
    event.stopImmediatePropagation();

    var button = form.querySelector('[type="submit"][name="add"]');
    if (button && button.getAttribute("aria-disabled") === "true") return true;

    var formData = new FormData(form);
    var idInput = form.querySelector('[name="id"]');
    var earringLine = { id: Number(idInput ? idInput.value : formData.get('id')), quantity: getQuantity(form) };
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') properties[match[1]] = value;
    });
    if (Object.keys(properties).length) earringLine.properties = properties;
    if (formData.get('selling_plan')) earringLine.selling_plan = Number(formData.get('selling_plan'));

    var notification = document.querySelector('cart-notification');
    var sections = [];
    try {
      if (notification && notification.getSectionsToRender) {
        sections = notification.getSectionsToRender().map(function (s) { return s.id; });
        if (notification.setActiveElement) notification.setActiveElement(document.activeElement);
      }
    } catch (e) {}

    var body = { items: [earringLine, { id: giftLine.id, quantity: giftLine.quantity }] };
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    showError(form, false);
    setLoading(form, true);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var addUrl = ((window.routes && window.routes.cart_add_url) || root + 'cart/add') + '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status || !Array.isArray(response.items)) {
          showError(form, response.description || response.message || (window.cartStrings && window.cartStrings.error));
          return;
        }
        // The cart drawer watches /cart/add requests and opens itself.
        if (document.querySelector('cart-drawer-lec')) return;
        if (notification && notification.renderContents && response.sections) {
          var item = response.items.find(function (i) { return i.variant_id === earringLine.id; }) || response.items[0];
          notification.renderContents(Object.assign({}, item, { sections: response.sections }));
          return;
        }
        window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
      })
      .catch(function (error) {
        console.error(error);
        showError(form, window.cartStrings && window.cartStrings.error);
      })
      .finally(function () {
        setLoading(form, false);
      });
    return true;
  }

  // Capture phase on window runs before every other submit/click handler on the page.
  window.addEventListener('submit', function (event) {
    addWithGift(event.target, event);
  }, true);

  window.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('button[type="submit"][name="add"]');
    if (!button) return;
    addWithGift(button.form, event);
  }, true);
})();

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      if (this.cartNotification) this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          if (!this.cartNotification) return;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
